import React from 'react';

const LegacyFooter: React.FC = () => (
  <footer className="legacy-footnote">
    <p>This website was created by Jason Conci in Pacifica, CA</p>
    <p>:)</p>
  </footer>
);

export default LegacyFooter;
